const betaWorkspaceUids = [
  'adlive',
  'kaaradaayumu',
  'tomoka',
  'konan-nojima-kensetsu',
  'ontheshore',
  'hcc_hothitoiki',
  'bellmare-condition',
  'ichinoshiki',
];

export const canUseTicketFeatures = (workspaceUid: string): boolean => {
  return betaWorkspaceUids.includes(workspaceUid);
};
